<template>
  <div v-if="server_info" class="server_info">
    <div class="server_info__left">
      <div class="server_info__left__wrap" ref="content">
        <div class="main_info" ref="main_info">
          <div class="line row">
            <div class="col-md-3 col-sm-3">
              <fg-input v-model="server_info.name" type="text" :label="translate('server.name/title')"
                        :placeholder="translate('server.name/title')"/>
            </div>

            <div class="col-md-3 col-sm-3">
              <fg-input v-model="server_info.name_short" type="text" :label="translate('server.name_short')"
                        :placeholder="translate('server.name_short')"/>
            </div>

            <div class="col-md-3 col-sm-3">
              <fg-input v-model="server_info.place" type="text" :label="translate('server.place')"
                        :placeholder="translate('server.place')" />
            </div>

            <div class="col-md-3 col-sm-3">
              <label> {{ translate('server.group') }} </label>
              <tree-select v-model="server_info.server_group_id" :options="server_group_list"
                           :placeholder="translate('server.group')" :clearable="false" :searchable="true" />
            </div>
          </div>

          <div class="line row">
            <div class="col-md-3 col-sm-3">
              <fg-input v-model="server_info.ip" type="text" label="IP" placeholder="IP" :readonly="true"/>
            </div>
            <div class="col-md-3 col-sm-3">
              <router-link :to="'/client/' + server_info.client_id" class="link">
                <fg-input v-model="server_info.client_name" type="text" :label="translate('server.client_name')"
                          :placeholder="translate('bank_payment.client_name')" :readonly="true" />
              </router-link>
            </div>
            <div class="col-md-3 col-sm-3">
              <fg-input v-model="server_info.max_devices" type="number" :label="translate('server.max_devices')"
                        :placeholder="translate('server.max_devices')" />
            </div>
            <div class="col-md-3 col-sm-3">
              <fg-input v-model="server_info.max_devices_per_instance" type="number" :label="translate('server.max_devices_per_instance')"
                        :placeholder="translate('server.max_devices_per_instance')" />
            </div>
          </div>

          <div class="line row">
            <div class="col-md-3 col-sm-3">
              <fg-input v-model="server_info.cost" type="text" :label="translate('server.cost')"
                        :placeholder="translate('server.cost')" />
            </div>
            <div class="col-md-3 col-sm-3">
              <fg-input v-model="server_info.hoster" type="text" :label="translate('server.hoster')"
                        :placeholder="translate('server.hoster')" />
            </div>

            <div class="col-md-3 col-sm-3">
              <fg-input v-model="server_info.virtualization_platform" type="text" :label="translate('server.virtualization_platform')"
                        :placeholder="translate('server.virtualization_platform')" :readonly="true"/>
            </div>
            <div class="col-md-3 col-sm-3">
              <div class="filter checkbox">
                <div class="info">
                  {{ translate('server.backup') }}
                </div>
                <label class="switch" @click.prevent="backup = !backup">
                  <input type="checkbox" v-model="backup">
                  <span class="slider round"></span>
                </label>
              </div>
            </div>
          </div>

          <div class="line row">
            <div class="col-md-12 col-sm-12 text_wrap">
              <div class="form-group">
                <label>{{ translate('server.description') }}</label>
                <textarea class="input_text" name="equipment" v-model="server_info.description" rows="3" />
              </div>
            </div>
          </div>

          <div class="line text-center buttons hide_for_print">
            <span v-if="has_changes" class="btn btn-success btn-fill btn-wd" @click.prevent="edit_server">
              {{ translate('btn.edit') }}
            </span>

          </div>
        </div>
      </div>

      <div class="response_table" ref="table_instance">
        <div class="header">
          <label class="title">
            {{ translate('server.table_instance.title') }} ({{instance_list.length}})
            ({{ translate('server.table_instance.total_devices') }}: {{ total_devices }})
          </label>

          <div class="buttons">
            <button class="btn-info btn-fill btn-wd add_instance"  @click.prevent="add_group_instance">
              {{ translate('server.add_group_instance') }}
            </button>
            <button class="btn-success btn-fill btn-wd add_instance"  @click.prevent="add_instance">
              {{ translate('server.add_instance') }}
            </button>
          </div>

        </div>

        <table>
          <thead style="height: 50px; flex:0; display: inline-block">
            <tr>
              <th class="min" scope="col">
                №
              </th>
              <th class="big" scope="col">
                {{ translate('server.table_instance.name') }}
              </th>
              <th class="mid" scope="col">
                {{ translate('server.table_instance.group_name') }}
              </th>
              <th class="big" scope="col">
                {{ translate('server.table_instance.iperf_settings') }}
              </th>
              <th scope="col">
                {{ translate('server.table_instance.description') }}
              </th>
              <th class="pointer mid" @click="change_filter('port')" :class="{ selected: filter_type === 'port' }"
                  scope="col">
                {{ translate('server.table_instance.port') }}
                <i class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }" />
              </th>
              <th class="pointer mid" @click="change_filter('type')" :class="{ selected: filter_type === 'type' }"
                  scope="col">
                {{ translate('server.table_instance.type') }}
                <i class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }" />
              </th>
              <th class="pointer mid" @click="change_filter('device_count')" :class="{ selected: filter_type === 'device_count' }"
                  scope="col">
                {{ translate('server.table_instance.device_count') }}
                <i class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }" />
              </th>
            </tr>
          </thead>
          <tbody>
          <tr
              v-for="(instance, key) in instance_list"
              :key="key"
              class="instance_item pointer"
              @click="open_instance(instance.id)"
          >
            <td :data-label="'№'" class="min">
              {{ key + 1 }}
            </td>
            <td :data-label="translate('server.table_instance.name')" class="big">
              <span> {{ instance.name }} </span>
            </td>
            <td :data-label="translate('server.table_instance.group_name')" class="mid">
              <span> {{ instance.group_name }} </span>
            </td>

            <td :data-label="translate('server.table_instance.iperf_settings')" class="big">
              <span> {{ instance.iperf_settings }} </span>
            </td>

            <td :data-label="translate('server.table_instance.description')">
              <span class="limit"> {{ instance.descr }} </span>
            </td>

            <td :data-label="translate('server.table_instance.port')" class="mid">
              <span> {{ instance.port }} </span>
            </td>

            <td :data-label="translate('server.table_instance.type')" class="mid">
              <span> {{ instance.type }} </span>
            </td>

            <td :data-label="translate('server.table_instance.device_count')" class="mid" @click.stop.prevent="">
              <router-link :to="'/device_list?&universal_search=instance_id:' + instance.id" >
                {{ instance.device_count }}
              </router-link>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="server_info__right">
      <Summary
          type="server"
          :info="server_info"
          :view_history="false"
      />
    </div>
  </div>

</template>
<script>

import Summary from "components/UIComponents/Summary/Summary.vue";
import WrapDatePicker from "components/UIComponents/WrapDatePicker/WrapDatePicker.vue";
import EditInstance from "./Modal/EditInstance.vue";
import AddInstance from "./Modal/AddInstance.vue";
import AddGroupInstance from "./Modal/AddGroupInstance.vue";

const fields_to_check = [
  "name",
  "name_short",
  "place",
  "cost",
  "hoster",
  "server_group_id",
  "backup",
  "max_devices",
  "max_devices_per_instance",
  "description"
];

export default {
  name: 'ServerInfo',
  components: {
    WrapDatePicker,
    Summary
  },

  props: {
    server: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      server_info: {},
      filter_asc: "asc",
      filter_type: "",
      groups_servers: [],
      backup: false,
    }
  },

  created() {
    this.get_servers_group()
    this.server_info = JSON.parse(JSON.stringify(this.server))
    this.backup = this.server.backup

    this.check_query()
  },

  activated() {
    this.get_servers_group()
    this.server_info = JSON.parse(JSON.stringify(this.server))
    this.backup = this.server.backup

    this.check_query()
  },

  computed: {
    total_devices(){
      return this.instance_list.reduce((total, instance) => total + Number(instance.device_count), 0);
    },
    start_url(){
      return this.$route.path
    },
    server_group_list(){
      return this.groups_servers.map((client) => {
        return { id: client.id, label: client.name }
      })
    },
    has_changes() {
      let main_info = fields_to_check.reduce((obj, key) => {
        obj[key] = this.server[key];
        return obj;
      }, {});

      let client_order_info = fields_to_check.reduce((obj, key) => {
        obj[key] = this.server_info[key];
        return obj;
      }, {});

      return JSON.stringify(main_info) !== JSON.stringify(client_order_info);
    },
    instance_list(){
      return this.server_info.instances.sort(this.compareNumbers);
    },
  },

  watch: {
    server(){
      this.server_info = {...this.server}

      this.server_info.instances = this.server_info.instances.map((instance) => {
        return { ...instance, edit: false }
      })
    },
    backup(){
      this.server_info.backup = this.backup ? 1 : 0
    }
  },

  methods: {
    add_group_instance(){
      let t = this.$createElement(AddGroupInstance, {
        props: {
          server_id: this.server_info.id,
        },
        on: {
          close: () => {
            this.$modal.hide('add_instance')
          },
          update: () => {
            this.$emit('update')
            this.$modal.hide('add_instance')
          }
        }
      })
      let temp = { render() { return t } }
      this.$modal.show(temp, {}, {
        height: 'auto',
        adaptive: true,
        clickToClose: true,
        name: 'add_instance'
      })
    },
    add_instance() {
      let t = this.$createElement(AddInstance, {
        props: {
          server_id: this.server_info.id,
          server_instance_groups: this.server_info.server_instance_groups
        },
        on: {
          close: () => {
            this.$modal.hide('add_instance')
          },
          update: () => {
            this.$emit('update')
            this.$modal.hide('add_instance')
          }
        }
      })
      let temp = { render() { return t } }
      this.$modal.show(temp, {}, {
        height: 'auto',
        adaptive: true,
        clickToClose: true,
        name: 'add_instance'
      })
    },
    check_query(){
      if (Object.keys(this.$route.query).length > 0){
        this.open_instance(this.$route.query.instance)
      }
    },
    open_instance(instance_id){
      history.pushState(null, null, this.$route.path + "?instance=" + instance_id)

      let t = this.$createElement(EditInstance, {
        props: {
          instance_id: instance_id,
          start_url: this.start_url
        },
        on: {
          close: () => {
            this.$modal.hide('edit_instance')
            // this.check_link = true
          },
          update: () => {
            this.$emit("update")
            this.$modal.hide('edit_instance')
          }
        }
      })
      let temp = { render() { return t } }
      this.$modal.show(temp, {}, {
        height: 'auto',
        adaptive: true,
        clickToClose: true,
        name: 'edit_instance'
      })
    },
    get_servers_group(){
      this.$http.v1.getServersGroup( (response) => {
        this.groups_servers = response.data
      })
    },
    edit_server() {
      if (this.has_changes){
        let server_info = fields_to_check.reduce((obj, key) => {
          obj[key] = this.server_info[key];
          return obj;
        }, {});

        this.$http.v1.updateServer(this.server_info.id, server_info, () => {
          this.global_notify('info', this.translate('server.saved_server_success'))
          this.$emit('update')
        })
      }
    },

  }
}

</script>

<style lang='scss' scoped>
.server_info {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  overflow: auto;

  @media (max-width: 991px) {
    flex-direction: column;
  }

  &__left {
    width: 70%;
    height: 100%;
    padding-right: 10px;
    @media (max-width: 991px) {
      width: 100%;
      height: auto;
    }

    .response_table {
      height: auto;
      padding: 0;
      .header{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;
        .buttons{
          display: flex;
          gap: 10px;
        }
      }
      table{
        td{
          //padding: 10px;
          span{
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 12px;
            height: 40px;
          }
          .limit{
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-overflow: ellipsis;
            line-height: 1.5em;
            max-height: 3em;
            font-size: 12px;
            margin-bottom: 0;
          }
        }
        .instance_item{
          &:hover{
            background-color: #eaeaea;
          }
        }

        .min{
          width: 3%;
          min-width: 20px;
          .mdi{
            font-size: 20px;
          }
        }
        .mid{
          width: 11%;
        }
        .big{
          width: 16%;
        }
      }
    }



    .buttons {
      margin-top: 10px;
      .btn{
        margin-right: 10px;
        &:last-child{
          margin-right: 0;
        }
      }
    }
  }

  &__right {
    width: 30%;
    height: 100%;
    @media (max-width: 991px) {
      width: 100%;
      height: auto;
    }
  }
}
</style>
